@if ((leadDashboardService.currentExamination$ | async) !== undefined) {
  <app-lead-task></app-lead-task>
} @else {
  <app-selected-leads-view></app-selected-leads-view>
}
